import { useAppContext } from '@/app/providers/AppContextProvider';

export function useHideHeader(): boolean {
	return useAppContext().hideHeader;
}
